/** * @description 参与考勤人员-筛选 * @author daxiong */
<template>
  <div id="participants">
    <section class="top-if">
      <van-search
        v-model="condition.staffName"
        placeholder="搜索"
        input-align="center"
        @input="getList()"
      />
      <div class="group-cub">
        <span class="group-name">{{ userInfo.entName }}</span>
      </div>
    </section>
    <!-- 全选 -->
    <section>
      <van-cell>
        <template #title>
          <van-checkbox v-model="radioAll" @click="radioAllClick"
            >全选</van-checkbox
          >
        </template>
      </van-cell>
    </section>

    <!-- 考勤组 -->
    <section class="group-box">
      <van-checkbox-group
        v-model="checkedList"
        ref="checkboxGroup"
        @change="checkedListChange"
        class="group-arr"
        v-if="!this.isArrow"
      >
        <van-cell
          v-for="(item, index) in groupList"
          :key="index"
          :style="!item.isCheckbox ? 'height: 46px;' : ''"
        >
          <template #title>
            <div style="display:flex">
              <van-checkbox :name="index">
                <div v-if="item.orgName" class="user_header">
                  <div>{{ item.orgName }} ({{ item.orgNumber || 0 }})</div>
                </div>
                <div v-else class="user_headers">
                  <div class="user_img"></div>
                  <div class="info">
                    <div class="name">{{ item.staffName }}</div>
                    <div class="entName">{{ item.postOffice }}</div>
                  </div>
                </div>
              </van-checkbox>
              <div @click="checkCll(item, index)" class="arrow_button">
                <van-icon v-if="!item.isCheckbox" name="arrow-down" />
                <van-icon v-else name="arrow-up" />
              </div>
            </div>
            <div class="subordinate_checkou" v-if="item.orgStaffs">
              <div
                v-for="(ite, inde) in item.orgStaffs"
                :key="inde"
                class="user_headers user_box"
                @click.stop="checkClls(ite, inde)"
              >
                <van-checkbox :name="ite.mobile">
                  <div class="user_img"></div>
                  <div class="info">
                    <div class="name">{{ ite.staffName }}</div>
                    <div class="entName">{{ ite.postOffice }}</div>
                  </div>
                </van-checkbox>
              </div>
            </div>
          </template>
        </van-cell>
      </van-checkbox-group>
    </section>

    <div class="confirm-box">
      <!-- @click="showCheckedAll = true" -->
      <div class="checked-number">
        已选择：{{ orgStaffs.length }}人 <van-icon name="arrow-up" />
      </div>
      <van-button type="info" size="small" @click="confirmCheckedIf"
        >确定({{ orgStaffs.length }}/{{ staffCount }})</van-button
      >
    </div>

    <!-- <van-popup
      v-model="showCheckedAll"
      class="checked-all-popup"
      position="bottom"
    >
      <div
        class="checked-personnel"
        v-for="(item, index) in participantsList"
        :key="index"
      >
        <div class="img">
          <van-icon name="user-circle-o" />
        </div>
        <div class="info">
          <div class="name">{{ item.staffName }}</div>
          <div class="entName">{{ item.entName }}</div>
        </div>
        <div class="det" @click="groupListDelete(item.mobile)">
          <van-icon name="close" />
        </div>
      </div>
      <div class="checked-confirm">
        <van-button type="info" class="confirm" @click="showCheckedAll = false"
          >确认</van-button
        >
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import { selectAllStaff, getEntEmployeeInfo } from '@api/lishui'
import { getLocalStorage } from '@utils'

export default {
  props: ['getType'],
  data() {
    return {
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      radioAll: false, // 是否全选
      condition: {},
      checkedList: [], // 已选中的唯一标识集合
      // isShowChild: false, // 是否显示组内成员
      showCheckedAll: false, // 是否显示已选中的成员弹框
      groupName: '', // 组名
      noStaffNameList: [], // 全部参与人员集合
      participantsShow: false,
      demparForm: {},
      moveOrgId: [],
      orgStaffs: [],
      staffCount: '',
      participantsList: this.$store.state.clock.groupParticipants || [],
      groupList: [],
      parti: [],
      isArrow: false
    }
  },
  computed: {},
  watch: {
    /**
     * @description 同步到已选中
     */
    moveOrgId(val, old) {
      console.log(val, old)
      if (val.length !== old.length) {
        let valLength = ''
        if (val.length > old.length) {
          // valLength = this.getArrDifference(val, old)
          valLength = val[val.length - 1]
          val.forEach(item => {
            if (valLength === item) {
              let list = this.groupList[item].orgStaffs || []
              if (list.length) {
                list.forEach(text => {
                  if (this.participantsList.indexOf(text.mobile) == -1) {
                    this.participantsList.push(text.mobile)
                    this.checkedList.indexOf(text.mobile) == -1
                      ? this.checkedList.push(text.mobile)
                      : ''
                  }
                })
              }
            }
          })
        } else {
          // if (old.length) {
          valLength = this.getArrDifference(val, old)
          valLength = old[old.length - 1]
          console.log(valLength, this.checkedList)
          this.groupList.forEach((item, index) => {
            if (!this.checkedList.includes(index) && index == valLength) {
              if (item.orgStaffs) {
                item.orgStaffs.forEach((value, index) => {
                  console.log(this.checkedList, value.mobile)
                  if (this.checkedList.includes(value.mobile)) {
                    var mobileIndex = this.checkedList.indexOf(value.mobile)
                    this.checkedList.splice(mobileIndex, 1)
                  }
                })
              }
            }
          })
          // }
        }
      }
    },
    participantsList(val, old) {
      console.log(val, old)
      if (val.length === 0) {
        this.radioAll = false
      }
      let valLength =
        val.length > old.length ? val[val.length - 1] : old[old.length - 1]
      // this.getArrDifference(val, old)
      console.log(valLength)
      this.groupList.forEach((item, index) => {
        var list = []
        // if (index == valLength) {
        if (item.orgStaffs && item.orgStaffs.length) {
          item.orgStaffs.map(text => {
            list.push(text.mobile)
          })
          let show = list.some(val => {
            return this.checkedList.includes(val)
          })
          let newShow = list.every(val => {
            return this.checkedList.includes(val)
          })
          if (!show) {
            this.checkedList.indexOf(index) !== -1
              ? this.checkedList.splice(this.checkedList.indexOf(index), 1)
              : ''
          }
          if (newShow) {
            this.checkedList.indexOf(index) == -1
              ? this.checkedList.push(index)
              : ''
          }
        }
        // }
      })
      // // 填充已选择的数据
      this.orgStaffs = []
      // this.checkedList.map(e => {
      this.groupList.map((value, index) => {
        if (value.orgStaffs) {
          value.orgStaffs.map((v, i) => {
            if (this.checkedList.includes(v.mobile)) {
              this.orgStaffs.push({
                staffName: v.staffName,
                mobile: v.mobile
              })
            }
          })
        }
        if (this.checkedList.includes(index)) {
          if (value.mobile) {
            this.orgStaffs.push({
              staffName: value.staffName,
              mobile: value.mobile
            })
          }
        }
      })
      // })
      // console.log(this.orgStaffs)
    }
  },
  methods: {
    // 取不同
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    radioAllClick() {
      this.$refs.checkboxGroup.toggleAll(this.radioAll)
    },

    /**
     * @description 删除已选中的参与人员
     * @param {string} mobile 唯一标识
     */
    groupListDelete(mobile) {
      let index = this.checkedList.findIndex(v => {
        return v === mobile
      })
      // debugger
      this.checkedList = [
        ...this.checkedList.slice(0, index),
        ...this.checkedList.slice(index + 1)
      ]
    },
    // 下级
    subordinate(e) {
      if (e.orgNumber && e.orgNumber > 0) {
        // this.participantsShow = true
        // this.demparForm = e
      }
    },
    checkedListChange(val, index) {
      // this.orgStaffs = []
      this.moveOrgId = []
      val.map(value => {
        if (typeof value == 'number') {
          this.moveOrgId.push(value)
        }
        let f = this.groupList[value]
        this.participantsList = []
        if (f) {
          this.checkedList.map(a => {
            if (value == a) {
              if (f.orgStaffs && f.orgStaffs.length > 0) {
                f.orgStaffs.map((old, oldex) => {
                  if (value != old.mobile) {
                    this.participantsList.push(old.mobile)
                  }

                  // this.orgStaffs.map(ald => {
                  //   if (ald.staffName != old.staffName) {
                  //     this.orgStaffs.push({
                  //       staffName: old.staffName,
                  //       mobile: old.mobile
                  //     })
                  //   }
                  // })
                })
              }
            }
          })

          // if (f.mobile) {
          //   this.orgStaffs.push({ staffName: f.staffName, mobile: f.mobile })
          // }
        } else {
          // this.groupList.map(e => {
          //   if (e.orgStaffs) {
          //     e.orgStaffs.map(l => {
          //       if (l.mobile === value) {
          //         this.orgStaffs.push({
          //           staffName: l.staffName,
          //           mobile: l.mobile
          //         })
          //       }
          //     })
          //   }
          // })
        }
      })
      if (this.parti.length > 0) {
        this.participantsList = this.parti
        this.checkedList = this.parti
      } else {
        if (!index) {
          this.participantsList = val
          this.checkedList = val
        }
      }
      this.parti = []
      // console.log(this.orgStaffs)
    },

    /**
     * @description 查询考勤人员
     */
    selectAllStaff() {
      selectAllStaff({
        creditCode: this.userInfo.creditCode,
        staffName: this.condition.staffName,
        belongId: window.location.href.includes('/groupEditor?id=')
          ? this.$route.query.id
          : ''
      }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.groupList = []
          this.groupList = [...res.data.orgList, ...res.data.notInOrgList]
          this.staffCount = res.data.staffCount
          this.participantsList = []
          this.groupList.map(value => {
            if (value.orgStaffs) {
              value.isCheckbox = false
            }
          })

          this.groupList.map((value, index) => {
            if (value.status === 1) {
              this.checkedList.push(index)
            }
            if (value.orgStaffs) {
              value.orgStaffs.map(val => {
                if (val.status === 1) {
                  this.checkedList.push(val.mobile)
                  // this.checkedList.map((text, i) => {
                  //   if (text !== index) {
                  //     this.checkedList.push(index)
                  //   }
                  // })
                }
              })
            }
          })
        } else {
          this.$notify({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    /**
     * @description 显示组内成员
     */
    showChild(item) {
      this.isShowChild = true
      this.groupName = item.groupName
    },
    checkCll(i, index) {
      this.parti = []
      this.parti = this.participantsList
      if (i.orgStaffs) {
        if (i.isCheckbox) {
          this.groupList[index].isCheckbox = false
        } else {
          this.groupList[index].isCheckbox = true
        }
      }
      if (!this.isArrow) {
        this.isArrow = true
      }
      this.isArrow = false
      // this.checkedListChange(
      //   !this.participantsList.length ? [index] : this.participantsList,
      //   1
      // )
    },
    checkClls(i, index) {
      // debugger
    },
    /**
     * @description 确认参与人员
     */
    confirmCheckedIf() {
      let obj = {}
      this.orgStaffs = this.orgStaffs.reduce((curs, next) => {
        obj[next.mobile] ? '' : (obj[next.mobile] = true && curs.push(next))
        return curs
      }, [])
      this.$store.commit('clock/setGroupParticipants', this.orgStaffs)
      this.$emit('closePopupByParticipants', this.orgStaffs)
    },

    getList() {
      this.selectAllStaff()
    }
  },
  created() {
    this.getList()
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
#participants {
  height: 100vh;
  font-size: 14px;
  section {
    margin-bottom: 8px;
    &.group-box {
    }
    &.top-if {
      background: #fff;
      padding-bottom: 10px;
      .group-cub {
        display: flex;
        align-items: center;
        margin-left: 20px;
        color: #999;
        i {
          margin: 0 5px;
        }
        .group-name {
          &.active {
            color: #0091ff;
          }
        }
      }
    }
  }
  .group-arr {
    box-sizing: border-box;
    height: calc(100vh - 182px);
    padding-bottom: 40px;
    overflow-y: auto;
  }
  ::v-deep .van-cell {
    padding-bottom: 0;
    .van-radio__icon,
    .van-checkbox__icon {
      width: 16px;
      height: 16px;
      font-size: 16px;
    }
    &__title {
      // display: flex;
      // align-content: center !important;
      // justify-content: space-between !important;

      .r-down {
        color: #0091ff;
        padding-left: 10px;
        border-left: 1px solid rgba(0, 0, 0, 0.05);
      }

      .van-checkbox__label {
        display: flex;
        align-items: center;

        .img {
          width: 42px;
          height: 42px;
          background: #0091ff;
          border-radius: 50%;
          margin-right: 10px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 62px;
          }
        }

        .info {
          .name {
            color: #333;
            margin-right: 9px;
            font-size: 16px;
            span {
              font-size: 12px;
              color: #0091ff;
              background: #b3deff;
              border: 1px solid #e9f5ff;
              border-radius: 4px;
              padding: 2px;
              margin-left: 5px;
            }
          }
          .entName {
            margin-top: 5px;
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
  }
  .subordinate_checkou {
    margin-top: 20px;
    padding: 0 10px 0;
    border-top: 1px solid rgba($color: #999, $alpha: 0.1);
    // border-top: 1px solid red;
  }
  .subordinate_status {
    height: 0;
    padding: 0;
    // margin: -5px 0 0 0;
  }
  .user_img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    vertical-align: middle;
    background: url('../../../../assets/images/lishui-user.png') no-repeat;
    background-size: 100%;
    margin: 0px 16px 0px 4px;
  }
  .user_box {
    padding: 10px 0;
    border-bottom: 1px solid rgba($color: #999, $alpha: 0.1);
  }
  .user_header {
    width: 310px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    margin-left: 6px;
    span {
      display: inline-block;
      padding-left: 10px;
      border-left: 1px solid rgba($color: #999, $alpha: 0.1);
      font-size: 16px;
      color: #0091ff;
      i {
        vertical-align: middle;
      }
    }
    .span_color {
      color: #999;
    }
  }
  .arrow_button {
    width: 100px;
    text-align: right;
    // border: 1px solid red;
    position: relative;
    left: 0;
    z-index: 100;
  }
  .user_headers {
    display: flex;
    align-items: center;
    width: 320px;
  }
  ::v-deep .van-search__content {
    border-radius: 17px;
  }

  .confirm-box {
    box-sizing: border-box;
    width: 100%;
    height: 75px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    .checked-number {
      color: #0091ff;
      display: flex;
      align-items: center;
      i {
        margin-left: 5px;
      }
    }
  }

  ::v-deep .checked-all-popup {
    width: 100vw;
    height: 100vh;
    background: #f7f7f7;
    .checked-personnel {
      height: 70px;
      background: #fff;
      display: flex;
      align-items: center;
      padding: 0 20px;
      position: relative;

      .det {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
        color: #999;
      }

      .img {
        width: 42px;
        height: 42px;
        background: #0091ff;
        border-radius: 50%;
        margin-right: 10px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 62px;
        }
      }

      .info {
        .name {
          color: #333;
          margin-right: 9px;
          font-size: 16px;
          span {
            font-size: 12px;
            color: #0091ff;
            background: #b3deff;
            border: 1px solid #e9f5ff;
            border-radius: 4px;
            padding: 2px;
            margin-left: 5px;
          }
        }
        .entName {
          margin-top: 5px;
          font-size: 12px;
          color: #666;
        }
      }
    }
    .checked-confirm {
      box-sizing: border-box;
      width: 100%;
      height: 75px;
      background: #fff;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.05);
      position: fixed;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .confirm {
        width: 100%;
        height: 40px;
      }
    }
  }
}
</style>
